var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5e3967",
    d: "M 996.292969 394.398438 L 996.292969 394.238281 C 932.34375 1.039062 511.128906 4.363281 506.855469 4.363281 C 505.804688 4.203125 504.746094 4.152344 503.6875 4.207031 C 461.898438 4.207031 78.355469 14.652344 16.78125 394.238281 C -2.949219 525.023438 21.324219 658.652344 85.796875 774.140625 C 195.539062 970.679688 337.800781 1147.195312 506.539062 1296.191406 C 675.1875 1147.152344 817.390625 970.644531 927.121094 774.140625 C 991.710938 658.753906 1016.046875 525.148438 996.292969 394.398438 Z M 506.539062 699.585938 C 462.066406 699.570312 418.597656 686.367188 381.628906 661.644531 C 344.660156 636.925781 315.851562 601.796875 298.847656 560.707031 C 281.84375 519.613281 277.40625 474.398438 286.097656 430.785156 C 294.789062 387.171875 316.21875 347.113281 347.675781 315.679688 C 379.132812 284.242188 419.207031 262.84375 462.828125 254.183594 C 506.449219 245.519531 551.65625 249.988281 592.738281 267.023438 C 633.820312 284.054688 668.925781 312.886719 693.621094 349.875 C 718.3125 386.859375 731.488281 430.335938 731.472656 474.808594 C 731.367188 534.417969 707.632812 591.558594 665.464844 633.691406 C 623.300781 675.828125 566.148438 699.523438 506.539062 699.585938 Z M 506.539062 699.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPurple);
export default __webpack_public_path__ + "static/media/pin_purple.500cccf1102d85bd7afad25f911dad2a.svg";
export { ForwardRef as ReactComponent };